import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { transactionDetails } from './transactionDetails/reducer'
import { verification } from './verification/reducer'
import { internalTools } from './internalTools/reducer'
import { businessVerification } from './businessVerification/reducer'
import { route } from './route/reducer'
import { team } from './team/reducer'
import { straitsXLandingPage } from './straitsXLandingPage/reducer'
import { straitsXTransactions } from './straitsXTransactions/reducer'
import { straitsXSimulateDeposit } from './straitsXSimulateDeposit/reducer'
import { straitsXEarn } from './straitsXEarn/reducer'
import { straitsXEarnTransactionDetails } from './straitsXEarnTransactionDetails/reducer'
import { depositInstructions } from './depositIntructions/reducer'
import { accounts } from './accounts/reducer'
import { merchantInfo } from './merchantInfo/reducer'
import { bankAccounts } from './bankAccounts/reducer'
import { blockchainAddresses } from './blockchainAddresses/reducer'
import { straitsXAccountStatement } from './straitsXAccountStatement/reducer'
import { swap } from './swap/reducer'
import { cards } from './cards/reducer'
import { flippers } from '~/store/flippers/reducer'
import { cardDetails } from './cardDetails/reducer'
import { assets } from '~/store/assets/reducer'

export const rootReducer = combineReducers({
  transactionDetails,
  verification,
  internalTools,
  businessVerification,
  route,
  depositInstructions,
  team,
  straitsXLandingPage,
  straitsXTransactions,
  straitsXSimulateDeposit,
  straitsXEarn,
  straitsXEarnTransactionDetails,
  accounts,
  merchantInfo,
  bankAccounts,
  blockchainAddresses,
  straitsXAccountStatement,
  swap,
  cards,
  cardDetails,
  flippers,
  assets,
})

const middlewares = [thunk]
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)))

export default store
